import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { Company } from 'app/models/company.model';
import { CompanyService } from 'app/services/company.service';
import { ConfirmationDialogComponent } from 'app/services/user-interaction/components/confirmation-dialog/confirmation-dialog.component';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { CompanyFormComponent } from '../company-form/company-form.component';
import { ContractListComponent } from '../contract-list/contract-list.component';
import { RoleMenuFormComponent, RoleModel } from '../role/role-menu-form/role-menu-form.component';
import { GlobalConfigFormComponent } from '../global-config-form/global-config-form.component';
import { GlobalConfig } from 'app/models/global-config.model';
import { CustomFuelInformationListComponent } from '../custom-fuelInformation-list/custom-fuelInformation-list.component';


@Component({
    selector: 'company-list',
    templateUrl: './company-list.component.html',
    styleUrls: ['./company-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class CompanyListComponent implements OnInit {


    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    private _companyList: Array<Company> = [];
    public get companyList(): Array<Company> {
        return this._companyList;
    }
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }
    private _dataSource: MatTableDataSource<Company> = undefined;
    public get dataSource(): MatTableDataSource<Company> {
        return this._dataSource;
    }

    private _displayedColumns = ['index', 'name', 'description', 'setting'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _fuseSidebarService: FuseSidebarService,
        private _spinner:NgxSpinnerService,
        private _dialog: MatDialog,
        private _toastService: ToasterService,
        private _CompanyService: CompanyService
    ) {
    }


    public async ngOnInit() {
        await this.getCompanyList();
    }

    private async getCompanyList(): Promise<Array<Company>> {
        try {
            this._spinner.show('loading')
            this._companyList = await this._CompanyService.getCompanies();
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<Company>(this._companyList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    public addCompany() {
        const dialog = this._dialog.open(CompanyFormComponent, {
            data: new Company(),
            disableClose: false
        });
        dialog.componentInstance.operation = "create"
        dialog.componentInstance.added.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });

    }
    public updateCompany(Company) {
        const dialog = this._dialog.open(CompanyFormComponent, {
            data: cloneDeep(Company),
            disableClose: false
        });
        dialog.componentInstance.model = cloneDeep(Company);
        dialog.componentInstance.operation = "update"
        dialog.componentInstance.updated.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });
    }
    public async deleteCompany(user: Company) {
        try {
            const dialog = this._dialog.open(ConfirmationDialogComponent,{

            })
            dialog.componentInstance.message = "Seçilen kurumu silmek istediğinize emin misiniz?"
            dialog.componentInstance.confirmed.subscribe(async(x)=>{
                var res = await this._CompanyService.delete(user);
                res ? this._toastService.toastSuccess():this._toastService.toastFail();
                dialog.close();
            })
            dialog.componentInstance.rejected.subscribe(async (x:any) => {
                dialog.close();
            })
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
        await this.refresh();
    }
    toggleSidebar(name): void {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    refresh() {
        this.getCompanyList();
    }

    public roleMenuClick(company:Company) {
        const dialog = this._dialog.open(RoleMenuFormComponent, {
            width: '1000px'
        });
        var Role = new RoleModel()
        Role.id='1';
        dialog.componentInstance.role = cloneDeep(Role);
        dialog.componentInstance.selectedCompany = company;
        dialog.componentInstance.added.subscribe((model: boolean) => {
            dialog.close();
        })
    }

    public async contractList(company: Company) {

        this._dialog.open(ContractListComponent,
            {
                data: company,
                disableClose: false,
            })
    }

    public onFuelInformationClick(company:Company) {
        const dialog = this._dialog.open(CustomFuelInformationListComponent,{
            width: '1000px',
            data:cloneDeep(company)
        })
        dialog.componentInstance.added.subscribe((model:any)=>{

            dialog.close();
        })
    }
}
